export const blue100 = "var(--seed-color-palette-blue-100)";
export const blue200 = "var(--seed-color-palette-blue-200)";
export const blue300 = "var(--seed-color-palette-blue-300)";
export const blue400 = "var(--seed-color-palette-blue-400)";
export const blue500 = "var(--seed-color-palette-blue-500)";
export const blue600 = "var(--seed-color-palette-blue-600)";
export const blue700 = "var(--seed-color-palette-blue-700)";
export const blue800 = "var(--seed-color-palette-blue-800)";
export const blue900 = "var(--seed-color-palette-blue-900)";
export const blue1000 = "var(--seed-color-palette-blue-1000)";
export const carrot100 = "var(--seed-color-palette-carrot-100)";
export const carrot200 = "var(--seed-color-palette-carrot-200)";
export const carrot300 = "var(--seed-color-palette-carrot-300)";
export const carrot400 = "var(--seed-color-palette-carrot-400)";
export const carrot500 = "var(--seed-color-palette-carrot-500)";
export const carrot600 = "var(--seed-color-palette-carrot-600)";
export const carrot700 = "var(--seed-color-palette-carrot-700)";
export const carrot800 = "var(--seed-color-palette-carrot-800)";
export const carrot900 = "var(--seed-color-palette-carrot-900)";
export const carrot1000 = "var(--seed-color-palette-carrot-1000)";
export const gray00 = "var(--seed-color-palette-gray-00)";
export const gray100 = "var(--seed-color-palette-gray-100)";
export const gray200 = "var(--seed-color-palette-gray-200)";
export const gray300 = "var(--seed-color-palette-gray-300)";
export const gray400 = "var(--seed-color-palette-gray-400)";
export const gray500 = "var(--seed-color-palette-gray-500)";
export const gray600 = "var(--seed-color-palette-gray-600)";
export const gray700 = "var(--seed-color-palette-gray-700)";
export const gray800 = "var(--seed-color-palette-gray-800)";
export const gray900 = "var(--seed-color-palette-gray-900)";
export const gray1000 = "var(--seed-color-palette-gray-1000)";
export const green100 = "var(--seed-color-palette-green-100)";
export const green200 = "var(--seed-color-palette-green-200)";
export const green300 = "var(--seed-color-palette-green-300)";
export const green400 = "var(--seed-color-palette-green-400)";
export const green500 = "var(--seed-color-palette-green-500)";
export const green600 = "var(--seed-color-palette-green-600)";
export const green700 = "var(--seed-color-palette-green-700)";
export const green800 = "var(--seed-color-palette-green-800)";
export const green900 = "var(--seed-color-palette-green-900)";
export const green1000 = "var(--seed-color-palette-green-1000)";
export const purple100 = "var(--seed-color-palette-purple-100)";
export const purple200 = "var(--seed-color-palette-purple-200)";
export const purple300 = "var(--seed-color-palette-purple-300)";
export const purple400 = "var(--seed-color-palette-purple-400)";
export const purple500 = "var(--seed-color-palette-purple-500)";
export const purple600 = "var(--seed-color-palette-purple-600)";
export const purple700 = "var(--seed-color-palette-purple-700)";
export const purple800 = "var(--seed-color-palette-purple-800)";
export const purple900 = "var(--seed-color-palette-purple-900)";
export const purple1000 = "var(--seed-color-palette-purple-1000)";
export const red100 = "var(--seed-color-palette-red-100)";
export const red200 = "var(--seed-color-palette-red-200)";
export const red300 = "var(--seed-color-palette-red-300)";
export const red400 = "var(--seed-color-palette-red-400)";
export const red500 = "var(--seed-color-palette-red-500)";
export const red600 = "var(--seed-color-palette-red-600)";
export const red700 = "var(--seed-color-palette-red-700)";
export const red800 = "var(--seed-color-palette-red-800)";
export const red900 = "var(--seed-color-palette-red-900)";
export const red1000 = "var(--seed-color-palette-red-1000)";
export const staticBlack = "var(--seed-color-palette-static-black)";
export const staticWhite = "var(--seed-color-palette-static-white)";
export const staticBlackAlpha50 = "var(--seed-color-palette-static-black-alpha-50)";
export const staticBlackAlpha200 = "var(--seed-color-palette-static-black-alpha-200)";
export const staticBlackAlpha500 = "var(--seed-color-palette-static-black-alpha-500)";
export const staticWhiteAlpha200 = "var(--seed-color-palette-static-white-alpha-200)";
export const staticWhiteAlpha800 = "var(--seed-color-palette-static-white-alpha-800)";
export const yellow100 = "var(--seed-color-palette-yellow-100)";
export const yellow200 = "var(--seed-color-palette-yellow-200)";
export const yellow300 = "var(--seed-color-palette-yellow-300)";
export const yellow400 = "var(--seed-color-palette-yellow-400)";
export const yellow500 = "var(--seed-color-palette-yellow-500)";
export const yellow600 = "var(--seed-color-palette-yellow-600)";
export const yellow700 = "var(--seed-color-palette-yellow-700)";
export const yellow800 = "var(--seed-color-palette-yellow-800)";
export const yellow900 = "var(--seed-color-palette-yellow-900)";
export const yellow1000 = "var(--seed-color-palette-yellow-1000)";